import { gql } from "graphql-request";

const SERVER_GET_ABSENCE_HISTORY_REPORT_FILTER = gql`
query ($filter: AbsenceHistoryReportFilter) {
  absenceHistoryReport(filter: $filter) {
    ...reportResultFragment
    __typename
  }
}

fragment reportResultFragment on ReportResult {
  id
  name
  executionTime
  headers
  rows
  error
  __typename
}
`

export default SERVER_GET_ABSENCE_HISTORY_REPORT_FILTER;
